var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1C4.365 1 1 4.365 1 8.5S4.365 16 8.5 16 16 12.635 16 8.5 12.635 1 8.5 1zm0 14.423A6.931 6.931 0 0 1 1.577 8.5 6.931 6.931 0 0 1 8.5 1.577 6.931 6.931 0 0 1 15.423 8.5 6.931 6.931 0 0 1 8.5 15.423z",
    fill: "#239A59",
    stroke: "#239A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.034 5.424 7.6 10.412 4.93 8.274a.291.291 0 0 0-.397.053.287.287 0 0 0 .037.398l2.885 2.308A.287.287 0 0 0 7.85 11l4.616-5.192a.29.29 0 0 0-.277-.473.285.285 0 0 0-.155.09z",
    fill: "#239A59",
    stroke: "#239A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizTickIcon);
export default __webpack_public_path__ + "static/media/quiz-tick-icon.f842a2b2.svg";
export { ForwardRef as ReactComponent };